import { useRoutes } from "react-router-dom";
import Login from "./Login";
import Registration from "./Registration";
import WaitingRoom from "./WaitingRoom";
const authRoutes = [
  {
    path: "login",
    element: <Login />,
  },
  {
    path: "registration",
    element: <Registration />,
  },
  {
    path: "waiting-room",
    element: <WaitingRoom />,
  },
];

const Auth = () => {

  const element = useRoutes([...authRoutes]);
  

  return <>{element}</>;
};

export default Auth;
